/**
 * Strip markdown formatting from text
 * Used for generating clean IDs and TOC items
 */
export function stripMarkdown(text: string): string {
  return text
    .replace(/\*\*([^*]+)\*\*/g, '$1')  // **bold**
    .replace(/\*([^*]+)\*/g, '$1')      // *italic*
    .replace(/__([^_]+)__/g, '$1')      // __underline__
    .replace(/_([^_]+)_/g, '$1')        // _italic_
    .replace(/~~([^~]+)~~/g, '$1')      // ~~strikethrough~~
    .replace(/`([^`]+)`/g, '$1')        // `code`
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // [link](url)
    .trim();
}
